"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { normalizeAddress } from "@opensea/utils";
import { ProfileHeaderFragment } from "@/components/profile/header/ProfileHeader.fragment";
import { ProfileJsonLdFragment } from "@/components/seo/ProfileJsonLD";
export const PROFILE_INFO_QUERY = graphql(`
    query ProfileInfoQuery($identifier: String!) {
      profileByIdentifier(identifier: $identifier) {
        __typename
        ... on Profile {
          address
          displayName
          ...ProfileHeader
          ...ProfileJsonLd

        }
      }
    }
  `, [ProfileHeaderFragment, ProfileJsonLdFragment]);

/**
 * Re-usable hook for fetching profile info for the profile page.
 */
export const useProfileInfo = (identifier, context) => {
  const $ = _c(11);
  let t0;
  if ($[0] !== identifier) {
    t0 = identifier ? normalizeAddress(identifier) : "";
    $[0] = identifier;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      identifier: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = !identifier;
  let t3;
  if ($[4] !== context || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      query: PROFILE_INFO_QUERY,
      variables: t1,
      pause: t2,
      context
    };
    $[4] = context;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const [t4] = useQuery(t3);
  const {
    data,
    fetching
  } = t4;
  const t5 = data?.profileByIdentifier?.__typename === "Profile" ? data.profileByIdentifier : null;
  let t6;
  if ($[8] !== fetching || $[9] !== t5) {
    t6 = {
      profile: t5,
      fetching
    };
    $[8] = fetching;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};